import { createAuthenticatedAxiosClient } from '@nx/axios-client'
import { BonhamsCookies } from '@nx/global-types'

export interface PatchBidProps {
  bidId: string
  baseURL: string
  amount: number
  isCancelled?: boolean
  cookies?: BonhamsCookies
}

export async function patchBid({
  bidId,
  baseURL,
  amount,
  cookies,
}: PatchBidProps) {
  const authenticatedAxiosClient = createAuthenticatedAxiosClient({
    accessTokenSSR: cookies?.bonhams_access || '',
    refreshTokenSSR: cookies?.bonhams_token || '',
    baseURL,
  })

  return authenticatedAxiosClient.patch(
    `/api/bbe/v1/maxbids/${bidId}`,
    { amount },
    {
      baseURL,
    }
  )
}
